import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ContenutoGenericoService} from '../service/contenuto-generico.service';
import {ContenutoGenerico} from '../model/contenuto-generico';
import {AllegatoService} from '../service/allegato.service';
import {Allegato} from '../model/allegato';
import {Search} from '../common/search';
import {MultilinguaService} from '../service/multilingua.service';
import {MenuService} from '../service/menu.service';
import {Multilingua} from '../model/multilingua';
import {Location} from '@angular/common';
import {QuotazioneService} from '../service/quotazione.service';
import {Quotazione} from '../model/quotazione.model';
import {SeoService} from '../service/seo.service';
import {DOCS_REPLACE} from '../constants/constants';

@Component({
    selector: 'app-investor',
    templateUrl: './investor.component.html',
})
export class InvestorComponent implements OnInit {

    public component: string = null;
    public element: ContenutoGenerico;
    public allegato: Allegato;
    public sottoInvestors: Array<ContenutoGenerico>;
    public loading = true;
    public servizio: string;
    public lingua: string;
    public quotazione: Quotazione;

    constructor(
        private contenutoService: ContenutoGenericoService,
        private multilingueService: MultilinguaService,
        private quotazioneService: QuotazioneService,
        private location: Location, private menuService: MenuService,
        private allegatoService: AllegatoService,
        private seoService: SeoService,
        public route: ActivatedRoute) {
        this.quotazioneService.latest().subscribe(
            borsa => {
                this.quotazione = borsa.items;
            });
    }

    ngOnInit() {
        this.route.url
            .subscribe(() => {
                const url = this.location.path().split('/');
                this.component = url.pop();
                this.contenutoService.find(this.component).subscribe(investor => {
                    this.element = investor;
                    if (this.element) {
                        this.lingua = this.element.lang;
                    }
                    this.getOtherLangs();

                    // this.seoService.addSeo(investor);
                    if (this.element && this.element.immagine) {
                        this.allegatoService.find(investor.immagine).subscribe(allegato => {
                            if (allegato) {
                                this.allegato = allegato;
                                this.allegato.path = DOCS_REPLACE(allegato.uuid);
                                this.seoService.setImage(this.allegato.path);

                            }
                        });
                    }
                    this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                    this.contenutoService.search._.contenitore = this.component;
                    this.contenutoService.search._.lang = this.lingua;
                    this.contenutoService.getAllList().subscribe(investors => {
                        this.sottoInvestors = investors;
                        this.loading = false;
                    });
                });
            });

    }

    getOtherLangs() {
        // console.log('searching for langs');
        this.multilingueService.search = new Search<Multilingua>(Multilingua);
        if (this.lingua === 'IT') {
            this.multilingueService.search._.it = this.element.uuid;
        } else if (this.lingua === 'EN') {
            this.multilingueService.search._.eng = this.element.uuid;
        }

        this.multilingueService.getList().subscribe(link => {
            const lingue = [];
            if (link && link.length > 0) {
                if (this.lingua === 'EN' && link[0].it) {
                    lingue.push('IT');
                }
                if (this.lingua === 'IT' && link[0].eng) {
                    lingue.push('EN');

                }
            }
            // console.log('pushing for langs');
            this.menuService.add(lingue);

        });


    }


}
